'use strict';

exports.__esModule = true;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _throttle2 = require('lodash/throttle');

var _throttle3 = _interopRequireDefault(_throttle2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _review = require('review');

var _peerRecommendation = require('peer-recommendation');

var _expandableSection = require('./expandable-section');

var _expandableSection2 = _interopRequireDefault(_expandableSection);

var _specialistListSection = require('./specialist-list-section');

var _specialistListSection2 = _interopRequireDefault(_specialistListSection);

var _infoSection = require('./info-section');

var _infoSection2 = _interopRequireDefault(_infoSection);

var _nonExpandableSection = require('./non-expandable-section');

var _nonExpandableSection2 = _interopRequireDefault(_nonExpandableSection);

var _articlesSection = require('./articles-section');

var _articlesSection2 = _interopRequireDefault(_articlesSection);

var _specialistTopNavHeader = require('./specialist-top-nav-header');

var _specialistTopNavHeader2 = _interopRequireDefault(_specialistTopNavHeader);

var _practiceTopNavHeader = require('./practice-top-nav-header');

var _practiceTopNavHeader2 = _interopRequireDefault(_practiceTopNavHeader);

var _practiceSpecialtiesSection = require('./practice-specialties-section');

var _practiceSpecialtiesSection2 = _interopRequireDefault(_practiceSpecialtiesSection);

var _practiceExpandableSection = require('./practice-expandable-section');

var _practiceExpandableSection2 = _interopRequireDefault(_practiceExpandableSection);

var _healthChecks = require('./health-checks');

var _healthChecks2 = _interopRequireDefault(_healthChecks);

var _doctifyUtils = require('doctify-utils');

var _style = require('../../src/styles/style.scss');

var _style2 = _interopRequireDefault(_style);

require('../../src/styles/external.scss');

var _reviewBreakdown = require('./review-breakdown');

var _reviewBreakdown2 = _interopRequireDefault(_reviewBreakdown);

var _reviewAverageRating = require('./review-average-rating');

var _reviewAverageRating2 = _interopRequireDefault(_reviewAverageRating);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProfileRightSection = function (_React$Component) {
  (0, _inherits3.default)(ProfileRightSection, _React$Component);

  function ProfileRightSection(props) {
    (0, _classCallCheck3.default)(this, ProfileRightSection);

    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));

    _this.DURATION = 500;
    return _this;
  }

  ProfileRightSection.prototype.componentDidMount = function componentDidMount() {
    if (!(0, _doctifyUtils.isServerSide)()) {
      if (this.peerRecommendationsSection && this.props.scrollToPeerRecommendations) {
        var _props = this.props,
            _disableScrollHighlight = _props.disableScrollHighlight,
            _setSectionActive = _props.setSectionActive,
            _headerClicked = _props.headerClicked,
            _enableScrollHighlight = _props.enableScrollHighlight;


        var peerRecommendationsSection = this.peerRecommendationsSection;
        var scrollDiv = this.scrollDiv;
        var DURATION = 2 * this.DURATION;

        var windowWidth = window.outerWidth || window.innerWidth || null;

        setTimeout(function () {
          _disableScrollHighlight();
          _setSectionActive('Peer Recommendations');

          /*When profile-right-section no longer has it's own scroll, then we scrolling html and calculating full top offset of element up to this html*/
          var scrollContainer = windowWidth <= 414 ? [document.getElementsByTagName('html')[0], document.getElementsByTagName('body')[0]] : scrollDiv;
          var isGetFullOffsetTop = windowWidth <= 414;

          _headerClicked(peerRecommendationsSection, scrollContainer, DURATION, isGetFullOffsetTop);

          setTimeout(function () {
            _enableScrollHighlight();
          }, DURATION);
        }, DURATION / 2);
      }
    }
  };

  ProfileRightSection.prototype.render = function render() {
    var _this2 = this;

    var props = this.props;

    var practiceId = props.practiceId,
        about = props.about,
        specialists = props.specialists,
        procedures = props.procedures,
        specialInterests = props.specialInterests,
        education = props.education,
        consultationFees = props.consultationFees,
        specialty = props.specialty,
        profileImage = props.profileImage,
        name = props.name,
        insurers = props.insurers,
        languages = props.languages,
        reviews = props.reviews,
        peerRecommendations = props.peerRecommendations,
        practiceAddress = props.practiceAddress,
        professionalRegistry = props.professionalRegistry,
        topLevelSpecialties = props.topLevelSpecialties,
        subspecialties = props.subspecialties,
        articles = props.articles,
        aboutSectionExpanded = props.aboutSectionExpanded,
        proceduresSectionExpanded = props.proceduresSectionExpanded,
        specialinterestsSectionExpanded = props.specialinterestsSectionExpanded,
        isLoggedIn = props.isLoggedIn,
        className = props.className,
        expandableSectionClicked = props.expandableSectionClicked,
        likeButtonClicked = props.likeButtonClicked,
        reportReviewClicked = props.reportReviewClicked,
        specialistListSelectionChanged = props.specialistListSelectionChanged,
        setSectionActive = props.setSectionActive,
        activeHeader = props.activeHeader,
        practiceSpecialties = props.practiceSpecialties,
        practiceAbout = props.practiceAbout,
        practiceReviews = props.practiceReviews,
        practiceInsurers = props.practiceInsurers,
        practiceAboutSectionExpanded = props.practiceAboutSectionExpanded,
        healthChecks = props.healthChecks,
        activeHealthChecks = props.activeHealthChecks,
        activePackages = props.activePackages,
        onHealthCheckSelected = props.onHealthCheckSelected,
        onHealthCheckPackageSelected = props.onHealthCheckPackageSelected,
        onScanSelected = props.onScanSelected,
        onScanPackageSelected = props.onScanPackageSelected,
        onBookButtonClicked = props.onBookButtonClicked,
        specialtyImage = props.specialtyImage,
        headerClicked = props.headerClicked,
        scrollEnabled = props.scrollEnabled,
        enableScrollHighlight = props.enableScrollHighlight,
        disableScrollHighlight = props.disableScrollHighlight,
        specialistUri = props.specialistUri,
        setPackageType = props.setPackageType,
        isCore = props.isCore,
        aggregateReview = props.aggregateReview,
        conditionsKeywords = props.conditionsKeywords,
        proceduresKeywords = props.proceduresKeywords,
        _props$loadSpecialist = props.loadSpecialistReviews,
        loadSpecialistReviews = _props$loadSpecialist === undefined ? function () {
      return null;
    } : _props$loadSpecialist;


    var aboutSection = void 0;
    var infoSection = void 0;
    var scrollDiv = this.scrollDiv;
    var proceduresSection = void 0;
    var interestsSection = void 0;
    var educationSection = void 0;
    var reviewsSection = void 0;
    var articlesSection = void 0;
    var insurersSection = void 0;
    var practiceSpecialtiesSection = void 0;
    var practiceAboutSection = void 0;
    var specialistsSection = void 0;
    var practiceReviewsSection = void 0;
    var practiceInsurersSection = void 0;
    var healthChecksSection = void 0;
    var peerRecommendationsSection = this.peerRecommendationsSection;

    var initialSections = void 0;
    var sections = [];
    var THROTTLE = 50;
    var DURATION = this.DURATION;

    var setActiveOnScroll = (0, _throttle3.default)(function () {
      if (!scrollEnabled) {
        return;
      }
      if (!initialSections) {
        initialSections = [infoSection, aboutSection, proceduresSection, interestsSection, educationSection, reviewsSection, peerRecommendationsSection, articlesSection, insurersSection, healthChecksSection, practiceSpecialtiesSection, practiceAboutSection, specialistsSection, practiceReviewsSection, practiceInsurersSection];
        initialSections.forEach(function (section) {
          if (section) {
            sections.push(section);
          }
        });
      }
      var viewportOffset = scrollDiv.getBoundingClientRect();
      var top = viewportOffset.top - window.scrollY;
      for (var i = 0; i < sections.length; i++) {
        if (sections[i].getBoundingClientRect().top - window.scrollY <= top && sections[i].getBoundingClientRect().bottom - window.scrollY > top) {
          var _title = sections[i].querySelector('h2').innerHTML;
          setSectionActive(_title);
          return;
        }
      }
    }, THROTTLE);

    var checks = healthChecks.filter(function (healthCheck) {
      return healthCheck.parent_name === 'Health Check';
    });
    var scans = healthChecks.filter(function (healthCheck) {
      return healthCheck.parent_name === 'Scan';
    });

    var windowWidth = typeof window !== 'undefined' && (window.outerWidth || window.innerWidth) || null; // 2nd is for iOS

    return _react2.default.createElement(
      'div',
      { className: className + ' ' + _style2.default.profileRightSection },
      _react2.default.createElement(
        'div',
        { className: _style2.default.sectionContainer },
        _react2.default.createElement(
          'div',
          { className: _style2.default.topNavContainer },
          _react2.default.createElement(
            'div',
            { className: _style2.default.topNav },
            _react2.default.createElement(
              'div',
              { className: _style2.default.scrollContainer },
              _react2.default.createElement(
                'div',
                { className: _style2.default.innerNav },
                ((subspecialties && subspecialties.length) > 0 || professionalRegistry && professionalRegistry.length > 0 || languages || peerRecommendations && peerRecommendations.length > 0 || consultationFees && consultationFees.length > 0 || practiceAddress && practiceAddress.length > 0) && _react2.default.createElement(_specialistTopNavHeader2.default, {
                  header: 'Info',
                  onClick: function onClick() {
                    disableScrollHighlight();
                    setSectionActive('Info');
                    headerClicked(infoSection, scrollDiv, DURATION);
                    setTimeout(function () {
                      enableScrollHighlight();
                    }, DURATION);
                  },
                  active: activeHeader === 'Info'
                }),
                about && _react2.default.createElement(_specialistTopNavHeader2.default, {
                  header: 'About',
                  onClick: function onClick() {
                    disableScrollHighlight();
                    setSectionActive('About');
                    headerClicked(aboutSection, scrollDiv, DURATION);
                    setTimeout(function () {
                      enableScrollHighlight();
                    }, DURATION);
                  },
                  active: activeHeader === 'About'
                }),
                procedures && _react2.default.createElement(_specialistTopNavHeader2.default, {
                  header: 'Procedures',
                  onClick: function onClick() {
                    disableScrollHighlight();
                    setSectionActive('Medical Procedures');
                    headerClicked(proceduresSection, scrollDiv, DURATION);
                    setTimeout(function () {
                      enableScrollHighlight();
                    }, DURATION);
                  },
                  active: activeHeader === 'Medical Procedures'
                }),
                specialInterests && _react2.default.createElement(_specialistTopNavHeader2.default, {
                  header: 'Interests',
                  onClick: function onClick() {
                    disableScrollHighlight();
                    setSectionActive('Special Interests');
                    headerClicked(interestsSection, scrollDiv, DURATION);
                    setTimeout(function () {
                      enableScrollHighlight();
                    }, DURATION);
                  },
                  active: activeHeader === 'Special Interests'
                }),
                education && _react2.default.createElement(_specialistTopNavHeader2.default, {
                  header: 'Education',
                  onClick: function onClick() {
                    disableScrollHighlight();
                    setSectionActive('Education');
                    headerClicked(educationSection, scrollDiv, DURATION);
                    setTimeout(function () {
                      enableScrollHighlight();
                    }, DURATION);
                  },
                  active: activeHeader === 'Education'
                }),
                reviews && reviews.length !== 0 && _react2.default.createElement(_specialistTopNavHeader2.default, {
                  header: 'Reviews',
                  onClick: function onClick() {
                    disableScrollHighlight();
                    setSectionActive('Reviews');
                    headerClicked(reviewsSection, scrollDiv, DURATION);
                    setTimeout(function () {
                      enableScrollHighlight();
                    }, DURATION);
                  },
                  active: activeHeader === 'Reviews'
                }),
                articles && articles.length !== 0 && _react2.default.createElement(_specialistTopNavHeader2.default, {
                  header: 'Articles',
                  onClick: function onClick() {
                    disableScrollHighlight();
                    setSectionActive('Articles on Doctify Journal');
                    headerClicked(articlesSection, scrollDiv, DURATION);
                    setTimeout(function () {
                      enableScrollHighlight();
                    }, DURATION);
                  },
                  active: activeHeader === 'Articles on Doctify Journal'
                }),
                healthChecks && healthChecks.length !== 0 && _react2.default.createElement(_practiceTopNavHeader2.default, {
                  header: 'Treatments',
                  onClick: function onClick() {
                    disableScrollHighlight();
                    setSectionActive('Treatments');
                    headerClicked(healthChecksSection, scrollDiv, DURATION);
                    setTimeout(function () {
                      enableScrollHighlight();
                    }, DURATION);
                  },
                  active: activeHeader === 'Treatments'
                }),
                practiceSpecialties && practiceSpecialties.length !== 0 && _react2.default.createElement(_practiceTopNavHeader2.default, {
                  header: 'Specialties',
                  onClick: function onClick() {
                    disableScrollHighlight();
                    setSectionActive('Specialties');
                    headerClicked(practiceSpecialtiesSection, scrollDiv, DURATION);
                    setTimeout(function () {
                      enableScrollHighlight();
                    }, DURATION);
                  },
                  active: activeHeader === 'Specialties'
                }),
                practiceAbout && _react2.default.createElement(_practiceTopNavHeader2.default, {
                  header: 'About',
                  onClick: function onClick() {
                    disableScrollHighlight();
                    setSectionActive('About');
                    headerClicked(practiceAboutSection, scrollDiv, DURATION);
                    setTimeout(function () {
                      enableScrollHighlight();
                    }, DURATION);
                  },
                  active: activeHeader === 'About'
                }),
                specialists && specialists.length !== 0 && _react2.default.createElement(_practiceTopNavHeader2.default, {
                  header: 'Specialists',
                  onClick: function onClick() {
                    disableScrollHighlight();
                    setSectionActive('Specialists');
                    headerClicked(specialistsSection, scrollDiv, DURATION);
                    setTimeout(function () {
                      enableScrollHighlight();
                    }, DURATION);
                  },
                  active: activeHeader === 'Specialists'
                }),
                practiceReviews && practiceReviews.length !== 0 && _react2.default.createElement(_practiceTopNavHeader2.default, {
                  header: 'Reviews',
                  onClick: function onClick() {
                    disableScrollHighlight();
                    setSectionActive('Reviews');
                    headerClicked(practiceReviewsSection, scrollDiv, DURATION);
                    setTimeout(function () {
                      enableScrollHighlight();
                    }, DURATION);
                  },
                  active: activeHeader === 'Reviews'
                }),
                practiceInsurers && practiceInsurers.length !== 0 && _react2.default.createElement(_practiceTopNavHeader2.default, {
                  header: 'Insurers',
                  onClick: function onClick() {
                    disableScrollHighlight();
                    setSectionActive('Insurers');
                    headerClicked(practiceInsurersSection, scrollDiv, DURATION);
                    setTimeout(function () {
                      enableScrollHighlight();
                    }, DURATION);
                  },
                  active: activeHeader === 'Insurers'
                })
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          {
            ref: function ref(div) {
              _this2.scrollDiv = div;
            },
            id: 'scrolldiv',
            className: _style2.default.subsectionScrollContainer,
            onScroll: function onScroll() {
              setActiveOnScroll(scrollEnabled);
            } },
          _react2.default.createElement(
            'div',
            { className: _style2.default.subsectionContainer },
            ((subspecialties && subspecialties.length) > 0 || professionalRegistry && professionalRegistry.length > 0 || languages || peerRecommendations && peerRecommendations.length > 0 || consultationFees && consultationFees.length > 0 || practiceAddress && practiceAddress.length > 0) && _react2.default.createElement(
              'div',
              { ref: function ref(section) {
                  infoSection = section;
                } },
              _react2.default.createElement(_infoSection2.default, {
                subspecialties: subspecialties,
                professionalRegistry: professionalRegistry,
                languages: languages,
                peerRecommendations: peerRecommendations,
                specialty: specialty,
                consultationFees: consultationFees,
                practices: practiceAddress,
                active: activeHeader === 'Info',
                peerRecommendationsLinkClicked: function peerRecommendationsLinkClicked() {
                  disableScrollHighlight();
                  setSectionActive('Peer Recommendations');

                  /*When profile-right-section no longer has it's own scroll, then we scrolling html and calculating full top offset of element up to this html*/
                  var scrollContainer = windowWidth <= 414 ? [document.getElementsByTagName('html')[0], document.getElementsByTagName('body')[0]] : scrollDiv;
                  var isGetFullOffsetTop = windowWidth <= 414;

                  headerClicked(peerRecommendationsSection, scrollContainer, DURATION, isGetFullOffsetTop);

                  setTimeout(function () {
                    enableScrollHighlight();
                  }, DURATION);
                },
                isCore: isCore
              })
            ),
            about && _react2.default.createElement(
              'div',
              { ref: function ref(section) {
                  aboutSection = section;
                } },
              _react2.default.createElement(_expandableSection2.default, {
                title: 'About',
                text: about,
                expanded: aboutSectionExpanded,
                onClick: function onClick() {
                  return expandableSectionClicked(aboutSectionExpanded, 'About');
                },
                active: activeHeader === 'About'
              })
            ),
            proceduresKeywords && proceduresKeywords.length > 0 && _react2.default.createElement(
              'div',
              { ref: function ref(section) {
                  proceduresSection = section;
                } },
              _react2.default.createElement(
                _expandableSection2.default,
                {
                  title: 'Medical Procedures',
                  expanded: proceduresSectionExpanded,
                  onClick: function onClick() {
                    return expandableSectionClicked(proceduresSectionExpanded, 'Procedures');
                  },
                  active: activeHeader === 'Medical Procedures'
                },
                proceduresKeywords.map(function (item) {
                  return _react2.default.createElement(
                    'p',
                    null,
                    item.name
                  );
                })
              )
            ),
            conditionsKeywords && conditionsKeywords.length > 0 && _react2.default.createElement(
              'div',
              { ref: function ref(section) {
                  interestsSection = section;
                } },
              _react2.default.createElement(
                _expandableSection2.default,
                {
                  title: 'Special Interests',
                  expanded: specialinterestsSectionExpanded,
                  onClick: function onClick() {
                    return expandableSectionClicked(specialinterestsSectionExpanded, 'specialinterests');
                  },
                  active: activeHeader === 'Special Interests'
                },
                conditionsKeywords.map(function (item) {
                  return _react2.default.createElement(
                    'p',
                    null,
                    item.name
                  );
                })
              )
            ),
            education && _react2.default.createElement(
              'div',
              { ref: function ref(section) {
                  educationSection = section;
                } },
              _react2.default.createElement(_nonExpandableSection2.default, {
                title: 'Education',
                text: education,
                active: activeHeader === 'Education'
              })
            ),
            reviews && reviews.length !== 0 && _react2.default.createElement(
              'div',
              {
                ref: function ref(section) {
                  reviewsSection = section;
                }, id: 'reviews',
                className: (activeHeader === 'Reviews' ? _style2.default.activeReviews : '') + ' ' + _style2.default.nonExpandableSubsection
              },
              _react2.default.createElement(
                'div',
                { className: '' + _style2.default['review-section-header'] },
                _react2.default.createElement(
                  'h2',
                  null,
                  'Verified Patient Reviews'
                ),
                _react2.default.createElement(
                  'div',
                  null,
                  'All reviews are from verified patients who have seen this specialists. If you\'d like more information on reviews, please have a look at our ',
                  _react2.default.createElement(
                    'a',
                    {
                      href: 'http://help.doctify.co.uk', target: '_blank', rel: 'noopener nofollow' },
                    'help center'
                  ),
                  '.'
                )
              ),
              aggregateReview && _react2.default.createElement(
                'div',
                { className: '' + _style2.default['review-overall-stats'] },
                _react2.default.createElement(
                  'div',
                  { className: '' + _style2.default['review-overall-stats__column'] },
                  _react2.default.createElement(_reviewBreakdown2.default, {
                    reviewsCount: aggregateReview.reviewsCount,
                    fiveStarsCount: aggregateReview.breakdown.fiveStarsCount,
                    fourStarsCount: aggregateReview.breakdown.fourStarsCount,
                    threeStarsCount: aggregateReview.breakdown.threeStarsCount,
                    twoStarsCount: aggregateReview.breakdown.twoStarsCount,
                    oneStarCount: aggregateReview.breakdown.oneStarCount
                  })
                ),
                _react2.default.createElement(
                  'div',
                  {
                    className: _style2.default['review-overall-stats__column'] + ' ' + _style2.default['review-overall-stats__column'] },
                  _react2.default.createElement(_reviewAverageRating2.default, {
                    bedsideMannerRating: aggregateReview.averageRating.bedsideManner,
                    explanationRating: aggregateReview.averageRating.explanation,
                    overallRating: aggregateReview.averageRating.overall
                  })
                )
              ),
              reviews.map(function (item, index) {
                return _react2.default.createElement(_review.ReviewAlt, {
                  key: index,
                  date: item.reviewDate,
                  review: item.review,
                  rating: item.numberOfStars,
                  ratings: item.ratings,
                  likes: item.likes,
                  profileImage: profileImage,
                  specialtyImage: specialtyImage,
                  specialist: name,
                  comment: item.comment,
                  loggedIn: isLoggedIn,
                  buttonClicked: item.liked,
                  onClick: function onClick() {
                    return likeButtonClicked(item.liked, index);
                  },
                  disableLikeButton: true
                  // onReportReview={() => reportReviewClicked(item)}
                  , starsClassName: _style2.default.stars,
                  isVerified: item.isVerified,
                  keywords: item.keywords
                });
              }),
              _react2.default.createElement(
                'button',
                {
                  style: { margin: '0 auto', backgroundColor: '#f41c5e', borderColor: '#f41c5e' },
                  className: 'btn d-block', onClick: function onClick() {
                    return loadSpecialistReviews();
                  }
                },
                'Load More'
              )
            ),
            peerRecommendations && peerRecommendations.length !== 0 && _react2.default.createElement(
              'div',
              {
                ref: function ref(section) {
                  _this2.peerRecommendationsSection = section;
                },
                className: (activeHeader === 'Peer Recommendations' ? _style2.default.activeReviews : '') + ' ' + _style2.default.nonExpandableSubsection },
              _react2.default.createElement(
                'h2',
                null,
                'Peer Recommendations'
              ),
              peerRecommendations.map(function (item, index) {
                return _react2.default.createElement(_peerRecommendation.PeerRecommendation, {
                  key: index,
                  recommendationDate: item.recommendationDate,
                  authorName: item.authorName,
                  authorProfileImage: item.authorProfileImage,
                  authorSpecialtyImage: item.authorSpecialtyImage,
                  recommendationText: item.recommendationText,
                  specialty: item.specialty,
                  conditions: item.conditions,
                  procedures: item.procedures,
                  connection: item.connection,
                  specialistUri: item.specialistUri
                });
              })
            ),
            articles && articles.length !== 0 && _react2.default.createElement(
              'div',
              { ref: function ref(section) {
                  articlesSection = section;
                }, className: _style2.default.articlesSection },
              _react2.default.createElement(_articlesSection2.default, {
                articles: articles,
                active: activeHeader === 'Articles on Doctify Journal'
              })
            ),
            healthChecks && healthChecks.length !== 0 && _react2.default.createElement(
              'div',
              {
                ref: function ref(section) {
                  healthChecksSection = section;
                },
                className: (activeHeader === 'Health Checks' ? _style2.default.activePracticeSection : '') + ' ' + _style2.default.healthChecksSection },
              checks && checks.length > 0 && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'h2',
                  null,
                  'Treatments'
                ),
                _react2.default.createElement(_healthChecks2.default, {
                  healthChecks: checks,
                  activeHealthCheckId: activeHealthChecks.healthCheck,
                  activePackageId: activePackages.healthCheck,
                  onHealthCheckSelected: onHealthCheckSelected,
                  onPackageSelected: onHealthCheckPackageSelected,
                  onBookButtonClicked: function (_onBookButtonClicked) {
                    function onBookButtonClicked(_x) {
                      return _onBookButtonClicked.apply(this, arguments);
                    }

                    onBookButtonClicked.toString = function () {
                      return _onBookButtonClicked.toString();
                    };

                    return onBookButtonClicked;
                  }(function (packageItem) {
                    (0, _doctifyUtils.fireGTMevent)('health_check_pp_click');
                    setPackageType('health_check');
                    onBookButtonClicked(packageItem);
                  }) })
              ),
              scans && scans.length > 0 && _react2.default.createElement(
                'div',
                { className: _style2.default.scansContainer },
                _react2.default.createElement(
                  'h2',
                  null,
                  'Scans'
                ),
                _react2.default.createElement(_healthChecks2.default, {
                  healthChecks: scans,
                  activeHealthCheckId: activeHealthChecks.scan,
                  activePackageId: activePackages.scan,
                  onHealthCheckSelected: onScanSelected,
                  onPackageSelected: onScanPackageSelected,
                  onBookButtonClicked: function (_onBookButtonClicked2) {
                    function onBookButtonClicked(_x2) {
                      return _onBookButtonClicked2.apply(this, arguments);
                    }

                    onBookButtonClicked.toString = function () {
                      return _onBookButtonClicked2.toString();
                    };

                    return onBookButtonClicked;
                  }(function (packageItem) {
                    (0, _doctifyUtils.fireGTMevent)('book_scan_pp_click');
                    setPackageType('scan');
                    onBookButtonClicked(packageItem);
                  }) })
              )
            ),
            practiceSpecialties && practiceSpecialties.length !== 0 && _react2.default.createElement(
              'div',
              { ref: function ref(section) {
                  practiceSpecialtiesSection = section;
                }, className: _style2.default.practiceSpecialtiesSection },
              _react2.default.createElement(_practiceSpecialtiesSection2.default, {
                specialties: practiceSpecialties,
                active: activeHeader === 'Specialties'
              })
            ),
            practiceAbout && _react2.default.createElement(
              'div',
              { ref: function ref(section) {
                  practiceAboutSection = section;
                }, className: _style2.default.practiceAboutSection },
              _react2.default.createElement(_practiceExpandableSection2.default, {
                title: 'About',
                text: practiceAbout,
                expanded: practiceAboutSectionExpanded,
                onClick: function onClick() {
                  return expandableSectionClicked(practiceAboutSectionExpanded, 'practiceAbout');
                },
                active: activeHeader === 'About'
              })
            ),
            specialists && specialists.length > 0 && _react2.default.createElement(
              'div',
              { ref: function ref(section) {
                  specialistsSection = section;
                },
                className: (activeHeader === 'Specialists' ? _style2.default.activePracticeSection : '') + ' ' + _style2.default.specialistsSection },
              _react2.default.createElement(_specialistListSection2.default, {
                practiceId: practiceId,
                specialists: specialists,
                topLevelSpecialties: topLevelSpecialties,
                onSelectSpecialty: function onSelectSpecialty(value) {
                  return specialistListSelectionChanged(value);
                }
              })
            ),
            practiceReviews && practiceReviews.length !== 0 && _react2.default.createElement(
              'div',
              { ref: function ref(section) {
                  practiceReviewsSection = section;
                }, id: 'practiceReviews',
                className: (activeHeader === 'Reviews' ? _style2.default.activePracticeReviews : '') + ' ' + _style2.default.nonExpandableSubsection + ' ' + _style2.default.practiceReviewsSection },
              _react2.default.createElement(
                'h2',
                null,
                'Reviews'
              ),
              practiceReviews.map(function (item, index) {
                return _react2.default.createElement(_review.Review, {
                  key: index,
                  date: item.reviewDate,
                  review: item.review,
                  rating: item.numberOfStars,
                  likes: item.likes,
                  profileImage: profileImage,
                  specialtyImage: specialtyImage,
                  specialist: name,
                  comment: item.comment,
                  loggedIn: isLoggedIn,
                  buttonClicked: item.liked,
                  onClick: function onClick() {
                    return likeButtonClicked(item.liked, index);
                  },
                  onReportReview: function onReportReview() {
                    return reportReviewClicked(item);
                  }
                });
              })
            )
          )
        )
      )
    );
  };

  return ProfileRightSection;
}(_react2.default.Component);

ProfileRightSection.displayName = 'ProfileRightSection';

ProfileRightSection.defaultProps = {
  about: '',
  procedures: '',
  specialInterests: '',
  education: '',
  consultationFees: [],
  specialty: '',
  profileImage: '',
  name: '',
  insurers: [],
  languages: '',
  reviews: [],
  peerRecommendations: [],
  practiceAddress: [],
  professionalRegistry: [],
  subspecialties: [],
  articles: [],
  aboutSectionExpanded: false,
  proceduresSectionExpanded: false,
  isLoggedIn: false,
  className: 'ProfileRightSection',
  setSectionActive: function setSectionActive() {},
  specialists: [],
  practiceSpecialties: [],
  practiceAbout: '',
  practiceReviews: [],
  practiceInsurers: [],
  healthChecks: [],
  activeHealthChecks: {
    healthCheck: null,
    scan: null
  },
  activePackages: {
    healthCheck: null,
    scan: null
  },
  isCore: false
};

exports.default = (0, _reactIntl.injectIntl)(ProfileRightSection);


// WEBPACK FOOTER //
// ./components/profile-right-section/lib/components/profile-right-section.js